import resizeObserver from './resize-observer';
import mutationObserverManager from './mutation-observer-manager';
import stylesManager from './styles-manager';
import dataset from './dataset';

let cachedScrollbarSize: number | undefined = undefined;
function getScrollbarSize(recalc: boolean = false) {
  if (recalc || cachedScrollbarSize === undefined) {
    const inner = document.createElement('div');
    inner.style.width = '100%';
    inner.style.height = '200px';

    const outer = document.createElement('div');
    const outerStyle = outer.style;

    outerStyle.position = 'absolute';
    outerStyle.top = '0';
    outerStyle.left = '0';
    outerStyle.pointerEvents = 'none';
    outerStyle.visibility = 'hidden';
    outerStyle.width = '200px';
    outerStyle.height = '150px';
    outerStyle.overflow = 'hidden';

    outer.appendChild(inner);

    document.body.appendChild(outer);

    const widthContained = inner.offsetWidth;
    outer.style.overflow = 'scroll';
    let widthScroll = inner.offsetWidth;

    if (widthContained === widthScroll) {
      widthScroll = outer.clientWidth;
    }

    document.body.removeChild(outer);

    cachedScrollbarSize = widthContained - widthScroll;
  }
  return cachedScrollbarSize;
}

/**
 * BE CAREFUL, this could be the bottleneck
 */
function forceStylesApplied(el: HTMLElement): void {
  const style = getComputedStyle(el);
  style.height;
}

const domService = {
  resizeObserver,
  getScrollbarSize,
  mutationObserverManager,
  stylesManager,
  dataset,
  forceStylesApplied,
};

export default domService;
